<script>
const handleShownEvent = function () {
	this.isOpen = true;
}

const handleHiddenEvent = function () {
	this.isOpen = false;
}
import Permissions from "@/mixins/shared/permissions";
export default {
	mixins: [Permissions],
	props: {
		entry: {
			type: Object,
			required: true,
		},
	},
	computed: {
		canEdit() {
			return this.can('edit menu content');
		}
	},
	methods: {
		getCollapseElement() {
			return this.$el.querySelector('.accordion-collapse');
		},

		async open() {
			if (this.isOpen) return;
			if (!this.canEdit) return;

			await new Promise((resolve) => {
				let element = this.getCollapseElement();
				let collapse = bootstrap.Collapse.getOrCreateInstance(element, { toggle: false });
				collapse.show();
				element.addEventListener('shown.bs.collapse', () => resolve(), { once: true });
			});

			// Vind de scrollbare parent container (bijv. modal body)
			const scrollContainer = this.$el.closest('.modal-body') || window;

			this.$el.scrollIntoView({
				behavior: 'smooth',
				block: 'center'
			});
		},

		async close() {
			if (!this.isOpen) return;

			await new Promise((resolve) => {
				let element = this.getCollapseElement();
				let collapse = bootstrap.Collapse.getOrCreateInstance(element, { toggle: false });
				collapse.hide();
				element.addEventListener('hidden.bs.collapse', () => resolve(), { once: true });
			});
		},

		async deleteEntry() {
			let result = await Helpers.Alert.confirm('Weet je zeker dat je deze menu item wilt verwijderen? onderliggende items worden ook verwijderd.');

			if (!result) {
				return;
			}

			$(document).trigger('wwdev.entry.delete', this.entry);
		}
	},
	mounted() {
		let element = this.getCollapseElement();
		element.addEventListener('shown.bs.collapse', handleShownEvent.bind(this));
		element.addEventListener('hidden.bs.collapse', handleHiddenEvent.bind(this));
	},
	unmounted() {
		let element = this.getCollapseElement();
		element.removeEventListener('shown.bs.collapse', handleShownEvent.bind(this));
		element.removeEventListener('hidden.bs.collapse', handleHiddenEvent.bind(this));
	},
	data() {
		return {
			isOpen: false,
			collapseId: 'collapse-' + this.entry.id,
		}
	}
}
</script>

<template>
	<div class="accordion">
		<div class="accordion-item">
			<h2 class="accordion-header">
				<button class="accordion-button collapsed"
				        :class="{'collapsed' : !isOpen, 'no-chevron': !canEdit}"
				        type="button"
				        :data-bs-toggle="canEdit ? 'collapse' : null"
				        :data-bs-target="canEdit ? `#${collapseId}` : null"
				        :aria-expanded="isOpen ? 'true' : 'false'"
				        :aria-controls="collapseId"
				        :disabled="!canEdit">
					<i class="bi bi-arrows-move sortable-handle"></i>
					<span class="ps-2">
                        <i v-if="entry.is_folder" class="bi bi-folder pe-2"></i>
                        <i v-else class="bi bi-link-45deg pe-2"></i>
                        {{ entry.label || entry.menu_item_label }}
                        <span v-if="entry.is_folder" class="badge bg-secondary ms-2">
                            {{ entry.children?.length || 0 }}
                        </span>
                    </span>
				</button>
			</h2>
			<div :id="collapseId" class="accordion-collapse bg-white collapse" :class="{'show' : isOpen}">
				<div class="accordion-body">
					<slot />

					<div v-if="canEdit" class="d-flex justify-content-end">
						<button type="button" @click="deleteEntry" class="btn btn-danger">
							<i class="bi bi-trash3"></i>
							Verwijderen
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.accordion-button.no-chevron::after {
	display: none;
}
</style>